module.exports = __webpack_public_path__ + "img/create-account.62fb7651.png";